import React from 'react';
import {
  Bot,
  ChefHat,
  Video,
  MessagesSquare,
  Dumbbell,
  MonitorPlay,
  BookOpen,
  Zap,
} from 'lucide-react';
import Reveal from './Reveal';

const ICONS = [ChefHat, Video, MessagesSquare, Dumbbell, MonitorPlay, BookOpen];

export default function Platform({ t }) {
  const p = t.platform;

  return (
    <section id="platform" className="relative bg-ink py-24 lg:py-32 overflow-hidden">
      <div className="absolute -top-20 left-1/4 w-[460px] h-[460px] rounded-full bg-volt-400/8 blur-[150px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full border border-volt-400/40 bg-volt-400/10 text-volt-400 text-xs font-bold uppercase tracking-[0.18em] mb-5">
              {p.kicker}
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-frost tracking-tight leading-tight">
              {p.title}
            </h2>
            <p className="mt-5 text-lg text-mist leading-relaxed">{p.sub}</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Big coach card */}
          <Reveal className="md:row-span-2">
            <div className="relative h-full rounded-3xl border border-volt-400/30 bg-gradient-to-b from-surface to-abyss p-8 overflow-hidden group">
              <div className="absolute -bottom-24 -right-24 w-64 h-64 rounded-full bg-volt-400/15 blur-[90px] group-hover:bg-volt-400/25 transition-colors duration-500" />
              <div className="relative flex flex-col h-full gap-6">
                <div className="w-14 h-14 rounded-2xl bg-volt-400 flex items-center justify-center shadow-volt-glow">
                  <Bot size={26} className="text-ink" />
                </div>
                <div>
                  <h3 className="font-display text-2xl font-bold text-frost mb-3">{p.coachTitle}</h3>
                  <p className="text-mist leading-relaxed">{p.coachDesc}</p>
                </div>
                <div className="mt-auto flex flex-col gap-4">
                  <span className="inline-flex items-center gap-2 w-fit px-4 py-2 rounded-full bg-volt-400/10 border border-volt-400/30 text-volt-400 text-xs font-bold">
                    <Zap size={13} fill="currentColor" />
                    {p.coachPill}
                  </span>
                  {/* Mini chat preview */}
                  <div className="rounded-2xl border border-line bg-ink/70 p-4 flex flex-col gap-2.5">
                    <div className="self-start max-w-[90%] rounded-xl rounded-bl-sm bg-raised px-3.5 py-2.5 text-xs text-frost border border-line">
                      {t.hero.chat[1].text}
                    </div>
                    <div className="self-end max-w-[70%] rounded-xl rounded-br-sm bg-pulse-500 px-3.5 py-2.5 text-xs text-white">
                      {t.hero.chat[2].text}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Six smaller cards */}
          {p.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={(i % 3) * 90}>
                <div className="group h-full rounded-3xl border border-line bg-surface p-7 hover:border-volt-400/40 hover:bg-raised transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="shrink-0 w-11 h-11 rounded-xl bg-raised border border-line flex items-center justify-center group-hover:border-volt-400/50 group-hover:bg-volt-400/10 transition-colors duration-300">
                      <Icon size={20} className="text-volt-400" />
                    </div>
                    <div>
                      <h3 className="font-display text-base font-bold text-frost mb-1.5">{item.title}</h3>
                      <p className="text-sm text-mist leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
